module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../node_modules/happypack/loader.js?id=jsx!./PeptideMilkAnnualPassView.js"));
	}, "PeptideMilkAnnualPassView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=PeptideMilkAnnualPassView!./src/pages/Shop/Member/Personal/PeptideMilkAnnualPass/PeptideMilkAnnualPassView.js
// module id = 989
// module chunks = 431